import React from "react";
import "../../../app/src/components/App/App.scss";

const Layout: React.FC = ({ children }) => {
  return <div className="cm-app">{children}</div>;
};

export { Layout };
